<template>
  <div class="Container">
    <el-container style="height: 100%;">
      <el-header class="header" v-if="!IsShowOnlyList && isShowHeader &&Type!==2" style="height: 50px;">
        <Header :isViewType="isViewTypeSub" @getComponent="getComponent"></Header>
      </el-header>
      <el-container :style="{'margin-top': !isLeftTemplateShow?'0px':'10px'}">
        <el-aside width="230px" v-show="isLeftTemplateShow" class="aside">
          <template-tag :Type="Type" :height="listHeight" :columns="columns" ref="templateTag" @getUserSerCond="getUserSerCond" @openSearch="openSearch" @getAllTask="getAllTask" @firstLoad="firstLoad" class="templateTag fl" :indexTit="templateTitleSub" :bigTitle="bigTemplateTitleSub" :isBlank="false" :ViewTypeState="ViewTypeStateSub" :isViewType="isViewTypeSub" :isBrowseRecords="isBrowseRecordsSub" :filedID="filedID">
          </template-tag>
        </el-aside>
        <el-container class="containeMain" :style="{'margin-left': !isLeftTemplateShow?'0px':'10px'}">
          <el-main>
            <slot v-if="IsShowCustomize" name="customize"></slot>
            <el-row v-if="IsShowButton && IsTwoRow" class="tagrow">
              <el-col :span="19">
                <slot v-if="Type!==2" name="button"></slot>
              </el-col>
              <el-col :span="5" class="tagSearch" style="padding-left: 15px;padding-right: 15px;">
                <div class="searchImgBack" @click="onSearch">
                  <img class="searchImg" src="../../assets/device/search.png" />
                </div>
                <el-input style="width: 100%;" v-show="isSearchSub" placeholder="请输入关键字" v-model="KeyWord" @keyup.enter.native="LuneceSearch" size="mini">
                  <el-button slot="append" icon="el-icon-search" @click="LuneceSearch"></el-button>
                </el-input>
                <!--<el-button style='width: 100%;margin-bottom: 10px;' @click="onSearch" size="mini" type="warning">精确搜索</el-button>-->
              </el-col>
            </el-row>
            <el-row v-if="IsShowButton && !IsTwoRow" class="tagrow">
              <el-col :span="isAccurateSearchSub?16:19">
                <slot v-if="Type!==2" name="button"></slot>
              </el-col>
              <el-col :span="4" v-if="isAccurateSearchSub && isAccurateSearch" style="text-align: right;padding: 5px 10px 0px 0px;">
                <slot v-if="IsShowCursomColumns" name="CursomColumns" />
                <el-button @click="onSearch" type="primary" class="more_thanfour_btn">精确搜索</el-button>
              </el-col>
              <el-col :span="4" class="tagSearch" v-if="isShowSearchInput" style="padding-top: 5px;">
                <el-input v-show="isSearchSub" placeholder="请输入关键字" v-model="KeyWord" @keyup.enter.native="LuneceSearch" size="medium">
                  <el-button slot="append" icon="el-icon-search" @click="LuneceSearch"></el-button>
                </el-input>
              </el-col>
            </el-row>
            <el-container class="containeMain">
              <el-main>
                <slot name="main" :Height="tableHeight"></slot>
              </el-main>
              <el-aside width="250px" v-show="expand==false?taskDetailShow:true" class="attbg">
                <Suspension v-show="expand" :Type="Type" ref="Suspension" :columns="columnsSub" :tableHeight="tableHeight" :filedID="filedIDSub" @detailsEvent="DetailsEvent" @deleteResult="deleteResult" @getValue="getValue"></Suspension>
              </el-aside>
            </el-container>
          </el-main>
        </el-container>
      </el-container>
    </el-container>
    <div class="suspension" v-if="IsExpandShow && Type==0 && isLeftTemplateShow">
      <el-button type="primary" @click="operationPanel" :icon="expand?'el-icon-d-arrow-right':'el-icon-d-arrow-left'" circle></el-button>
    </div>
  </div>
</template>
<script>
	import templateTag from "./template/templateTagNew.vue";
	import Suspension from "./template/suspension.vue";
	import Header from "./header.vue";
	import { mapState } from "vuex";
	export default {
		data() {
			return {
				defaultShow: true, //默认显示左侧模板
				searchText: "",
				expand: this.IsExpand,
				listHeight: "100%",
				tableHeight: 0,
				query: this.$route.query.query,
				KeyWord: "",

				isViewTypeSub: this.isViewType,
				columnsSub: this.columns,
				templateTitleSub: this.templateTitle,
				bigTemplateTitleSub: this.bigTemplateTitle,
				ViewTypeStateSub: this.ViewTypeState,
				isBrowseRecordsSub: this.isBrowseRecords,
				//isSearchSub: this.isSearch,
				isAccurateSearchSub: this.isAccurateSearch,
				filedIDSub: this.filedID,
				rows: this.$route.query.rows,

			};
		},
		props: {
			IsTwoRow: {
				//搜索框和精确搜索分为两行
				type: Boolean,
				default: false
			},
			IsExpand: {
				type: Boolean,
				default: false
			},
			IsExpandShow: {
				type: Boolean,
				default: false
			},
			templateTitle: {
				type: String,
				default: "任务模板管理"
			},
			bigTemplateTitle: {
				type: String,
				default: "任务模板"
			},
			isViewType: {
				type: Boolean,
				default: false
			},
			columns: {
				type: Array,
				default: () => {
					return [];
				}
			},
			category: {
				type: [Number, String],
				default: 6
			},
			isBrowseRecords: {
				//是否显示浏览记录
				type: Boolean,
				default: false
			},
			IsShowCursomColumns: {
				//是否实现表格动态列
				type: Boolean,
				default: false
			},
			styelTableHeight: {
				type: Number,
				default: 240
			},
			styelHeight: {
				type: Number,
				default: 100
			},
			isSearch: {
				type: Boolean,
				default: true
			},
			isAccurateSearch: {
				type: Boolean,
				default: true
			},
			filedID: {
				type: String,
				default: "ID"
			},
			IsShowCustomize: {
				//是否显示自定义插槽
				type: Boolean,
				default: false
			},
			IsShowButton: {
				//是否显示按钮区域
				type: Boolean,
				default: true
			},
			Type: {
				type: Number,
				default: 0
			},
			IsShowOnlyList: { //是否只显示列表
				type: Boolean,
				default: false
			},
			isShowHeader: { //是否显示header
				type: Boolean,
				default: true
			},
			// isShowSearchButton:{//是否显示精确搜索按钮
			//   type:Boolean,
			//   default:true
			// },
			isShowSearchInput: { //是否显示精确文本框
				type: Boolean,
				default: true
			}
		},
		components: {
			templateTag,
			Suspension,
			Header
		},
		computed: {
			isSearchSub() {
				return this.isSearch
			},
			...mapState({
				ViewTypeState: state => state.task.ViewTypeState,
				searchCondition: state => state.task.searchCondition,
				TemplateMenu: state => state.task.TemplateMenu,
			}),
			//是否显示左侧模板
			isLeftTemplateShow() {
				return(!this.IsShowOnlyList && this.defaultShow)
			},
			isHearderMenu() {
				return this.$store.state.task.TemplateMenu.length > 0
			},
			taskDetailShow() {
				return this.$store.state.task.type == 1 ? true : false;
			}
		},
		watch: {
			searchCondition(val) {
				let a = $(window).height();
				this.listHeight = a - this.styelHeight + "px";
				this.tableHeight = a - this.styelTableHeight - (val.length > 0 ? 40 : 0);
				// this.$refs.tag.$el.offsetHeight
			}
		},
		created() {
			this.$store.state.task.category = this.category;
			// this.debouncedSearch = _.debounce(this.getSearch, 500);
		},
		methods: {
			getLeftAndAll(isLoadMenu) {
				this.$refs.templateTag.getLeftAndAll(isLoadMenu);
			},
			getUserSerCond(cond) {
				this.$emit("getUserSerCond", cond);
			},
			getComponent(data) { //菜单组件返回方法
				if(data.NAME == '首页') {
					this.defaultShow = true;
				} else {
					this.defaultShow = false;
				}
				this.$emit("getComponent", data);
			},
			deleteResult(data) {
				console.log("deleteResult", data);
				//结果集删除
				this.$emit("deleteResult", data);
			},
			onSearch() {
				console.log("人员精确搜索");

				if(this.$refs.templateTag != undefined) {
					let templateContent = null;
					if(this.$refs.templateTag.templateQuery) {
						templateContent = this.$refs.templateTag.templateQuery;
					}
					this.$emit("openSearch", templateContent, 1);
				} else {
					this.$emit("openSearch", null, 1);
				}
			},
			operationPanel() {
				//操作结果库面板是否显示
				if(this.expand) {
					this.expand = false;
					this.$store.state.task.isExpand = false;
					this.$store.commit("setIsCheckbox", false);
				} else {
					this.expand = true;
					this.$store.state.task.isExpand = true;
					this.$store.commit("setIsCheckbox", true);
				}
				console.log(this.expand);
			},
			LuneceSearch() {
				this.$emit("LuneceSearch", this.KeyWord);
			},
			DetailsEvent(row) {
				this.$emit("DetailsEvent", row);
			},
			openSearch(row) {
				console.log('search', row);
				// //精确搜索
				// let templateContent = {};
				//   if (row.TEMPTYPE == 0) {
				//     templateContent = JSON.parse(
				//       row.CONTENT
				//     );
				//   }
				this.$emit("openSearch", row, 0);
			},
			getAllTask(data) {
				console.log("点击执行Container-->data:", data);

				this.templateQuery = data;
				//点击模板方法
				this.$emit("getAllTask", data);
			},
			firstLoad() {
				//页面第一次加载方法
				this.$emit("firstLoad");
			},
			getValue() {
				parent.getValue(routeUrl.href)
				// this.$emit("getValue");
			}
		},
		mounted() {
			this.$nextTick(() => {
				let a = $(window).height();
				this.listHeight = a - this.styelHeight + "px";

				this.tableHeight =
					a - this.styelTableHeight - (this.searchCondition.length > 0 ? 40 : 0);
				// alert(this.tableHeight)
				// alert(this.styelTableHeight);
				// alert(this.searchCondition.length);
				// this.$refs.tag.$el.offsetHeight
			});
			if(this.Type != 1) {
				this.$refs.templateTag.getLeftAndAll(); // 获取左侧和所有模板
			}

			if(this.Type === 2) {
				this.expand = true;
				this.$store.state.task.isExpand = true;
				this.$store.commit("clearResult");
				this.$store.commit("setIsCheckbox", true);
			}

			if(this.query) {
				this.query = JSON.parse(this.query);
				document.title = this.query.NAME;
				this.getAllTask(this.query);
			} else {

			}
			if(this.rows) {
				let list = JSON.parse(this.rows);
				this.list.forEach(c => {
					this.$store.commit("addResult", {
						row: c,
						filed: this.filedID,
						key: c[this.filedID],
						bol: false
					});
				});
			}
		}
	};
</script>

<style lang="scss" scoped>
  .el-aside {
    overflow: hidden;
  }

  .Container {
    height: 100%;
    font-family: MicrosoftYaHei;
    color: #165dbd;
    background: #e9eef1;
    .header {
      padding: 0;
      background: white;
    }
    .suspension {
      z-index: 500;
      position: fixed;
      bottom: 50%;
      right: 0px;
    }
    .aside {
      background: white;
      // border-right: 1px solid #000;
    }
    .el-main {
      padding: 0px;
    }
    .el-tabs {
      background: white;
    }
    .footer {
      line-height: 50px;
      padding: 0px 0px 0px 10px;
    }
    .attbg {
      box-sizing: border-box;
      position: relative;
      margin-left: 10px;
      background: white;
    }
    .tagrow {
      // height: 40px;
      // line-height: 40px;
      padding: 8px 10px 8px 10px;
      border-bottom: 1px solid #eaecf2;
    }
  }
</style>
<style scoped>
  .searchImgBack {
    width: 100%;
    border: 1px dashed gainsboro;
    border-radius: 5px;
    text-align: center;
    line-height: 30px;
  }

  .searchImgBack :hover {
    /*	width: 100%;*/
    background-color: ghostwhite;
  }

  .searchImg {
    width: 50%;
    height: 28px;
  }

  .searchImg :hover {
    width: 60% !important;
    height: 28px;
  }

  .Container >>> .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .Container >>> .el-tabs {
    background: white;
    height: 100%;
  }

  .Container >>> .el-tabs__header {
    margin: 0;
  }

  .containeMain >>> .el-main {
    padding: 0px;
    background: white;
  }
</style>